/**
 * Pickable recipients for a bid approval — sourced from the live Entra directory
 * (all vari.com staff with a jobTitle), falling back to provisioned platform
 * users. Supervisor/admin only. The bid editor also allows a custom name +
 * email for non-platform recipients (§A).
 */
import { useQuery } from '@tanstack/react-query';
import { apiCall } from '@/lib/api';

export interface Recipient {
  id: string;
  display_name: string;
  email: string;
  job_title: string | null;
}

export interface RecipientsResponse {
  source: 'directory' | 'platform';
  data: Recipient[];
}

export function useRecipients(enabled = true) {
  return useQuery<RecipientsResponse>({
    queryKey: ['users', 'recipients'],
    enabled,
    queryFn: () => apiCall<RecipientsResponse>('/users/recipients'),
    staleTime: 5 * 60 * 1000,
  });
}
